import { useAuth0 } from '@auth0/auth0-react';
import { store } from 'stores/Store';
const useExternalApiService = (baseURL) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const getAccessToken = async () => {

    try {
      const token = await getAccessTokenSilently();
      //console.log('Access Token procured = ', token);
      return token;
    } catch (error) {
      console.error('Error getting access token:', error);
      throw error;
    }
  };

  const getData = async (endpoint, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        signal,
      });
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

  const postData = async (endpoint, data, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const patchData = async (endpoint, data, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const putData = async (endpoint, data, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const deleteData = async (endpoint, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const postDataWithFormData = async (endpoint, data, signal) => {
    try {
      const token = await getAccessToken();
          // Post the form data to the API
      const response = await fetch(`${baseURL}${endpoint}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            // 'Content-Type': 'multipart/form-data'
          },
          body: data,
          signal
      })

      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const loadPractitionerGoals = async () => {

    if (!isAuthenticated) return;


    const endpoint = '/api/e/call_winback_goals_by_email';
    const data = {
      fmc_email: store.impersonatedUser 
    }
    
    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }

      const res = await response.json()
      store.setPractitionerGoals(res.payload)
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const loadFMCInfo = async () => {

    if (!isAuthenticated) return;
    console.log("store.impersonatedUser=", store.impersonatedUser)
    const endpoint = '/api/e/call_winback_get_fmc_info';
    const data = {
      fmc_email: store.impersonatedUser 
    }
    store.setInitialLatLon();
    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        console.error('Error loading FMC Info');
        // throw new Error(`Error posting data: ${response.statusText}`);
      }

      const res = await response.json()
      //store.setPractitionerGoals(res.payload)
      store.setImpersonatedUserName(res.fmc_name);
      store.setImpersonatedNetsuiteID(res.fmc_netsuite_id);
      store.setImpersonatedRsdName(res.rsd);
      store.setImpersonatedRsdEmail(res.rsd_email);
      store.setImpersonatedUserAlias(res.alias);
      const [lat, lon] = res?.latLon;
      if (lat && lon)  {
        console.log("Loaded latlon", lat, lon);
        store.setInitialLatLon([parseFloat(lat), parseFloat(lon)]);
      }
      console.log("res:", res);
      console.log("Name=", store.impersonatedUserName);
      console.log("NetsuiteID=", store.impersonatedUserNetsuiteID);
      console.log("RSD=", store.impersonatedUserRsdName);
      console.log("RSD Email=", store.impersonatedUserRsdEmail);
      console.log("Store's alias=", store.impersonatedUserAlias);
    } catch (error) {
      console.error('Error loading FMC Info', error);
      // throw error;
    }
  };

  const uploadImage = async (file, metadata = {}) => {
    if (!isAuthenticated) return;

    // Security validation
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
    const maxSize = 10 * 1024 * 1024; // 10MB
    const maxFileNameLength = 255;

    // Validate file exists
    if (!file) {
      throw new Error('No file provided');
    }

    // Validate file type
    if (!allowedTypes.includes(file.type)) {
      throw new Error(`Invalid file type. Allowed types: ${allowedTypes.join(', ')}`);
    }

    // Validate file size
    if (file.size > maxSize) {
      throw new Error(`File too large. Maximum size: ${maxSize / (1024 * 1024)}MB`);
    }

    // Validate file name length
    if (file.name && file.name.length > maxFileNameLength) {
      throw new Error(`File name too long. Maximum length: ${maxFileNameLength} characters`);
    }

    // Validate file name for security (no path traversal, no special chars)
    if (file.name && (file.name.includes('..') || file.name.includes('/') || file.name.includes('\\'))) {
      throw new Error('Invalid file name. File name contains illegal characters');
    }

    // Additional security: check file extension matches MIME type
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const mimeTypeMap = {
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'webp': 'image/webp',
      'gif': 'image/gif'
    };

    if (fileExtension && mimeTypeMap[fileExtension] !== file.type) {
      throw new Error('File extension does not match file type');
    }

    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('metadata', JSON.stringify(metadata));
      
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}/api/upload-image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Error uploading image: ${response.statusText}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  };

  return { getData, postData, postDataWithFormData, uploadImage, loadPractitionerGoals, loadFMCInfo, patchData, deleteData, putData, getAccessToken };
}



export default useExternalApiService;